import { useEffect, useState } from "react";
import Link from "next/link";
import Image, { StaticImageData } from "next/image";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconDefinition } from "@fortawesome/pro-solid-svg-icons";
import {JSX} from "react";

import styles from "@@/styles/components/header/DropdownItem.module.scss";

import { useHeaderCategoryContext } from "@@/hooks/contexts/headerCategroyContext";
import {montserratRegular} from "@@/utils/fonts";


interface IDropdownItemProps {
	title: string
	description?: string
	link: string
	img?: StaticImageData
	icon?: IconDefinition
	colors?: {
		background?: string
		backgroundHover?: string
		icon?: string
	}
	bgImg?: StaticImageData;
	imgClassName?: string;
	className?: string;
}

export default function DropdownItem(props: IDropdownItemProps): JSX.Element {
	const { title, description, link, img, icon, colors, bgImg, className, imgClassName } = props;

	const [bgColor, setBgColor] = useState<string>("");
	const [bgImage, setBgImage] = useState<string>("");

	const { setHoveredCategory, } = useHeaderCategoryContext();

	useEffect(() => {
		if (colors?.background) {
			setBgColor(colors.background);
		}
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	function enterHandler() {
		if (colors?.backgroundHover) {
			setBgColor(colors.backgroundHover);
		}

		if (bgImg) {
			setBgImage(`url("${bgImg.src}")`);
		}
	}

	function leaveHandler() {
		if (colors?.background) {
			setBgColor(colors.background);
		} else {
			setBgColor("");
		}

		setBgImage("");
	}

	function closeHandler() {
		setHoveredCategory(undefined);
	}

	return (
		<Link href={link} className={`${styles.main} flex-1 flex-none-mobile p-2 p-0-mobile min-h-fit min-w-150 d-flex align-items-center gap-2 ${className} ${bgImg ? styles.hasBgImg : ''}`} style={{ backgroundColor: bgColor, backgroundImage: `url("${bgImg?.src ?? ''}")`, }} onMouseEnter={enterHandler} onMouseLeave={leaveHandler} onClick={closeHandler}>
			{(icon || img ) ? (
				<div className={styles.img_div}>
					{img && <Image src={img} alt="" width={img.width} height={img.height} className={`${styles.image} ${imgClassName}`} />}
					{icon && <FontAwesomeIcon icon={icon} className={styles.icon} style={{ color: colors?.icon ?? "", }} />}
				</div>
				): ''
			}

			<div className={`${styles.text} h-100 min-h-fit d-flex flex-column justify-center color-blue`}>
				<h2 className={`${montserratRegular.className}`}>{title}</h2>
				{description && (<p>{description}</p>)}
			</div>
		</Link>
	);
}
